import { __decorate } from "tslib";
import { InputMultilistboxInstruction, InputSelectbuttonInstruction, LayoutPanelInstruction } from '@common/instructions/frontend-shared';
import { AccessGuard, accessGuardData, FrontendFeaturePlugin, provideFeatureAddonRoutes, provideRootRoutes } from '@core/frontend-shared';
import { UserRole } from '@core/shared/access';
import { ClassName } from '@core/shared/class-name';
import { VirtualPropertyHelper } from '@core/shared/virtual-properties';
import { CourseItem, MandatoryCourseGroupItem } from '@mpf/courses/shared';
import { CourseStateModule } from './state/course-state.module';
import { CoursesResolver } from './state/courses.resolver';
import * as i0 from "@angular/core";
let MpfCoursesFrontendFeature = /*#__PURE__*/(() => {
  let MpfCoursesFrontendFeature = class MpfCoursesFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/courses/frontend","featureId":"mpf-courses"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        profile: [{
          label: 'Meine Pflichtkurse',
          routerLink: './mandatory-courses',
          priority: 7,
          simpleAbilityCheck: {
            allow: [[UserRole.MANAGER, "Feature.mpf-courses.Manage"]]
          }
        }, {
          label: 'Meine Zertifikate',
          routerLink: './certificates',
          simpleAbilityCheck: UserRole.REGISTERED,
          priority: 7
        }]
      });
      functionality.defineModelInstructions([{
        modelId: 'UserItem',
        displayForEditorDefinitions: ['manager'],
        instructions: [
        // Management area currently uses custom editor.
        // also the required conditional display logic does not exist yet.
        new LayoutPanelInstruction({
          title: 'Pflichtkurs-Einstellungen',
          instructions: [new InputSelectbuttonInstruction({
            formControlName: VirtualPropertyHelper.accessor('mandatoryCourseGroup'),
            label: 'Pflichtkurs-Gruppe',
            deselectable: true,
            breakpoint: 960,
            optionsDynamic: {
              model: MandatoryCourseGroupItem,
              useCrudEndpoint: 'manager'
            },
            optionValue: 'id',
            help: "Sie können die Pflichtkurse für Ihre Mitarbeiter sowohl über Gruppen, als auch individuell festlegen." + "Um Gruppen zu nutzen, legen Sie diese zunächst unter >Pflichtkurs-Gruppen an." + "Um für den Mitarbeiter individuelle Pflichtkurse festzulegen, stellen Sie die Gruppe auf \"Keine\" ein."
          }), new InputMultilistboxInstruction({
            formControlName: VirtualPropertyHelper.accessor('mandatoryCourses'),
            label: 'Pflichtkurse (manuelle Auswahl)',
            filter: true,
            showToggleAll: true,
            optionsGroupedBy: {
              groupProp: 'category',
              groupDataKey: 'id',
              groupOrdering: {
                field: 'ordering',
                direction: 'ASC'
              }
            },
            optionsDynamic: {
              model: CourseItem,
              useCrudEndpoint: 'public',
              queryParams: {
                withExamOrCertificate: '1'
              }
            },
            optionValue: 'id',
            conditional: {
              display: model => !VirtualPropertyHelper.get(model, 'mandatoryCourseGroup')
            }
          })]
        })]
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfCoursesFrontendFeature_BaseFactory;
        return function MpfCoursesFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵMpfCoursesFrontendFeature_BaseFactory || (ɵMpfCoursesFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfCoursesFrontendFeature)))(__ngFactoryType__ || MpfCoursesFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfCoursesFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'courses',
          loadChildren: () => import('./courses-frontend.module').then(m => m.CoursesFrontendModule)
        }]), provideFeatureAddonRoutes([{
          useAddonSlot: 'user/profile',
          path: 'mandatory-courses',
          canActivate: [AccessGuard],
          data: {
            ...accessGuardData({
              allow: [[UserRole.MANAGER, "Feature.mpf-courses.Manage"]]
            })
          },
          loadComponent: () => import('./profile-integration/mandatory-courses').then(m => m.MandatoryCoursesProfileIntegrationComponent)
        }, {
          useAddonSlot: 'user/profile',
          path: 'certificates',
          canActivate: [AccessGuard],
          data: {
            ...accessGuardData({
              allow: [UserRole.REGISTERED]
            })
          },
          loadComponent: () => import('./profile-integration/certificates').then(m => m.CertificatesProfileIntegrationComponent),
          resolve: {
            courses: CoursesResolver
          }
        }])],
        imports: [CourseStateModule]
      });
    }
  };
  MpfCoursesFrontendFeature = __decorate([ClassName("MpfCoursesFrontendFeature")], MpfCoursesFrontendFeature);
  return MpfCoursesFrontendFeature;
})();
export { MpfCoursesFrontendFeature };